import axios from "./configs/axiosConfig";

export const getJBWAgreementDetails = async (jbwAgreementID) => {
  const url = `/jbwagreements/agreement/${jbwAgreementID}`;
  return await axios.get(url);
};
